import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HotTopics from "./components/HotTopics";
import VersionLog from "./components/VersionLog";
import Download from "./components/Download";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HotTopics />
        <VersionLog />
        <Download />
        <Faq />
      </main>
      <Footer />
    </>
  );
}